import { CountryCode } from '@csp/csp-common-model';
import { TechnicalSupportEntry } from '../../technical-support/model/TechnicalSupportEntry';
import { getGenericTechnicalSupport } from './getGenericTechnicalSupport';
import { getStudyTechnicalSupport } from './getStudyTechnicalSupport';

/**
 * Get study specific technical support content, or fallback to generic content if not found.
 *
 * @param countryCode Country code to fetch content for.
 *
 * @return Technical support content for the requested country.
 */
export const getTechnicalSupportWithFallback = (countryCode: CountryCode): TechnicalSupportEntry => {
  try {
    return getStudyTechnicalSupport(countryCode);
  } catch {
    return getGenericTechnicalSupport(countryCode);
  }
};
